import pickerEn from './picker/en.json';
import pickerZhHant from './picker/zh-Hant.json';
import pickerVi from './picker/vi.json';
import pickerTh from './picker/th.json';

export default {
  en: pickerEn,
  'zh-Hant': pickerZhHant,
  vi: pickerVi,
  th: pickerTh,
};
